module.exports = __webpack_public_path__ + "img/rs.b1128f39.svg";